<template>
  <el-dialog
    title="添加补单类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form size="small">
      <el-form-item label="所属分类" :label-width="formLabelWidth">
        <el-select v-model="typeLabel">
          <el-option label="顶级分类" value="0"></el-option>

          <el-option
            :value="cat.id"
            :label="cat.name"
            :key="cat.id"
            v-for="cat in addform.catList"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="分类名称"
        prop="typeName"
        :label-width="formLabelWidth"
      >
        <el-input v-model="typeName" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addType" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import OrderApi from "@/api/order.js";
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      typeLabel: "0",
      /*左边长度*/
      formLabelWidth: "120px",
      typeName: ""
    };
  },
  props: ["open_add", "addform"],
  created() {
    this.dialogVisible = this.open_add;
    console.log(this.open_add,this.addform, "--------");
  },
  methods: {
    // 添加类型
    addType() {
      let self = this;
      self.loading = true;
      let params = {
        name: self.typeName,
        pid: self.typeLabel
      };
      self.loading = true;
      OrderApi.addRepairOrderType(params)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style scoped lang="sass"></style>



// WEBPACK FOOTER //
// src/views/order/supplement/Add.vue